import React, { useState, useEffect } from 'react';
import './homeiframe.css';
import { Link, useNavigate,  useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { showToast } from '../toastUtils';
import FullscreenLoader from '../FullscreenLoader';
//for sorting icon implementation
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons';
import { queuedApiFetch, apiFetch } from '../api';

const MySwal = withReactContent(Swal);

function Homeiframe() {    
    const [originalRows, setOriginalRows] = useState([]);
    const [rows, setRows] = useState([]);
    const [projectName, setProjectName] = useState([]);
    const [selectedProject, setSelectedProject] = useState(''); 
    const [loading, setLoading] = useState(true);
    const accountId = localStorage.getItem('accountId');
    const [searchQuery, setSearchQuery] = useState('');
    const getUserDetails = localStorage.getItem('userDetails');
    const userDetails = getUserDetails ? JSON.parse(getUserDetails): '';
    const userId = userDetails ? userDetails.id : '';
    const getUserAccess = userDetails ? userDetails.access_level : '';
    // for get company details    
    const getUserEmail = localStorage.getItem('userEmail');
    const [scNumber, setSCNumber] = useState(0);
    const [userCompany, setUserCompany] = useState(0);
    const [userPermission, setUserPermission] = useState(0);
    const getUserCompanyDetails =userCompany;
    const [isFetched, setIsFetched] = useState(false); 
    const navigate = useNavigate();
    const [dataFetched, setDataFetched] = useState(false);
    const [userRoleManual, setUserRolesManual] = useState();
    // const getProjectDetails = localStorage.getItem('projectDetails');
    // const selectedProjectDetail = JSON.parse(getProjectDetails);
    // const defaultProjectNumber = selectedProjectDetail.projectNumber;
    const getProjectDetails = localStorage.getItem('projectDetails');
    const selectedProjectDetail = getProjectDetails ? JSON.parse(getProjectDetails) : null;
    const defaultProjectNumber = selectedProjectDetail ? selectedProjectDetail.projectNumber : null;
    
          // This useEffect will run whenever scNumber is updated
          // useEffect(() => {
          //   if (scNumber !== 0) {  
          //     openCreateProjectPopup(); 
          //   }
          // }, [scNumber]); 
    
    
        
        useEffect(() => {
          const fetchData = async () => {
              try {
                if (!dataFetched) {
            
                  await fetchUserCompany();
                  await fetchUserRole();
                  await getProjectList();
                  
                  // await fetchUserDetails();
                  setDataFetched(true);
                }
              } catch (error) {
                  console.error("Error fetching data:", error);
              }finally {
                // setLoading(false); 
              }
          };
          fetchData();
      }, []);

      const fetchUserRole = async () => {
        const requestOptions = {
          method: 'GET',
          //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
        };
         try {
          const response = await queuedApiFetch(`/project/get_project_role?userid=${userId}&projectid=${defaultProjectNumber}`, requestOptions);
          const data = await response;
      
          if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
          // console.log(data.data); 
          setUserRolesManual(data.data);
          //setUserRolesManual('Project Director (PD)');
          }
        } catch (error) {
          console.error('Error fetching data:', error);
        } finally {
        //   setLoading(false); // End loading
        }
      }
    
      const GlobalPermissionChecker = (
        expectedCompany,
        // accountAdminPermissions = [],
        projectAdminRoles = []
      ) => {
        return !(
          (getUserCompanyDetails === expectedCompany && userPermission === 'account_admin') ||
          (getUserCompanyDetails === expectedCompany && userPermission === 'project_admin' && userRoleManual === '') ||
          (getUserCompanyDetails === expectedCompany && userPermission === 'project_admin' && projectAdminRoles.some(item=>userRoleManual?.includes?.(item)))
        );
      };

      const Init_new_proj_sts=()=>{
        return (getUserCompanyDetails==='NUS' && userPermission === 'account_admin');
      };

      const Cost_data_sts = (
        expectedCompany,        
        projectAdminRoles = []
      ) => {
        return (
          (getUserCompanyDetails === expectedCompany && userPermission === 'account_admin') ||          
          (getUserCompanyDetails === expectedCompany && userPermission === 'project_admin' && projectAdminRoles.some(item=>userRoleManual?.includes?.(item)))
        );
      };


    
        const handleSearch = (event) => {
            const query = event.target.value.toLowerCase();
            setSearchQuery(query);
            if (query === '') {
              // If the search query is empty, refetch data
              getProjectList(); // Re-fetch data from the API
            } else {
              // Filter rows based on search query
              const filteredData = originalRows.filter((row) =>
                row.Proj_Name.toLowerCase().includes(query) || 
                // row.Proj_Number.toLowerCase().includes(query) ||
                row.SC_Number.toLowerCase().includes(query)
              );          
              setRows(filteredData);
            }
          };
    
          const location = useLocation();
          useEffect(() => {
            // If the URL path is `/` (root), redirect to `/homeacc`
            if (location.pathname === '/') {
              navigate('/homeacc');
            }
          }, [location, navigate]);

    // console.log('SC Number',scNumber);
    const getProjectList = async () => {
      // setLoading(true); 
      const requestOptions = {
        method: 'GET',
        // headers: new Headers({
        //     'ngrok-skip-browser-warning': '69420', 
        //     'Content-Type': 'application/json',   
        //   }),
      };
      // let t_userId='64261d49-66ae-4e1b-944b-12790c596db0';
      // let t_getUserEmail='kueklw@nus.edu.sg';

      try {
        const response = await queuedApiFetch(`/project/get_user_projectlist?userid=${userId}&email_id=${getUserEmail}`, requestOptions);
        const data = await response;
        
        if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
          const projectNames = data.data.map(item => ({
            name: item.Proj_Name,
            number: item.Proj_Number,
            // urn: item.URN
          }));
    
          setProjectName(projectNames);
          setOriginalRows(data.data);
          setRows(data.data);
    
          if (getProjectDetails) {
            const selectedProjectDetail = JSON.parse(getProjectDetails);
            const getProjectName = selectedProjectDetail.projectName;

            // old code
            // setSelectedProject(getProjectName);

            //new code
            setSelectedProject('');
          }
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false); // End loading
      }
    };

    const formatCurrency = (amount) => {
      return new Intl.NumberFormat('en-US', { 
        style:'currency', 
        currency: 'USD', 
        currencyDisplay: 'symbol' // This will display the currency code (USD) instead of the symbol.
      }).format(amount);
    };

    const fetchUserCompany = async () => {
      if (isFetched) return; 
      setIsFetched(true);
      const requestOptions = {
        method: 'GET',
        //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
      };
       try {
        const response = await queuedApiFetch(`/user/getuserprofile?emailid=${getUserEmail}`, requestOptions);
        const data = await response;
    
        if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
          setUserCompany(data.data.company_name);
          setUserPermission(data.data.access_level);
          //setUserPermission('project_admin');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        // setLoading(false); // End loading
      }
    }


    // const fetchUserDetails = async () => {
    //   const requestOptions = {
    //     method: 'GET',
    //     //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
    //   };
  
    //   try {
    //     const response = await queuedApiFetch(`/project/get_sc_no`, requestOptions);
    //     const data = await response;
        
    //     if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
    //       setSCNumber(data.data);  // Update scNumber state
    //     }
    //   } catch (error) {
    //     console.error('Error fetching data:', error);
    //   } finally {
    //     setIsFetched(true);  
    //   }
    // };




      const goToSelectedProject = (getprojectName) => {
        const selectedProject = projectName.find(project => project.number === getprojectName);
        if (selectedProject) {
            setSelectedProject(selectedProject.name);            
            localStorage.setItem('projectDetails', JSON.stringify({
                projectName: selectedProject.name,
                projectNumber: selectedProject.number,
                // URN: selectedProject.urn
            }));
            localStorage.setItem('lastActiveRoute', '/plans');
            navigate('/plans');
        }
      }
      
    const handleProjectSelect = (event) => {
      const selectedProjectNumber = event.target.value;
  
      if (selectedProjectNumber === '') {
          // Reset selectedProject and remove from localStorage
          setSelectedProject('');
          localStorage.removeItem('projectDetails');
      } else {
          const selectedProject = projectName.find(project => project.number === selectedProjectNumber);          
          if (selectedProject) {
              setSelectedProject(selectedProject.name);
              localStorage.setItem('projectDetails', JSON.stringify({
                  projectName: selectedProject.name,
                  projectNumber: selectedProject.number,
                  // URN: selectedProject.urn
              }));
          }
      }
  };

  const [pmEmailList, setPmEmailList] = useState([]);
  const [pdEmailList, setPdEmailList] = useState([]);
  
  
  const [pmSearch, setPmSearch] = useState('');
  const [pdSearch, setPdSearch] = useState('');
  const [filteredPmEmails, setFilteredPmEmails] = useState([]);
  const [filteredPdEmails, setFilteredPdEmails] = useState([]);
  
  // useEffect(() => {
  //     // Fetch email list from API
  //     const fetchEmailList = async () => {
  //         try {
  //             const response = await queuedApiFetch(`/project/get_initiate_new_project`);
  //             const data = await response;
              
  //             if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
  //                 setPmEmailList(data.data.pm_email_list);
  //                 setPdEmailList(data.data.pd_email_list);
                  
  //             }
  //         } catch (error) {
  //             console.error('Error fetching email list:', error);
  //         }
  //     };
      
  //     fetchEmailList();
  // }, []);
  
  // Handle PM Email search
  useEffect(() => {
      if (pmSearch === '') {
          setFilteredPmEmails([]);
      } else {
          setFilteredPmEmails(pmEmailList.filter(email => email.email.toLowerCase().includes(pmSearch.toLowerCase())));
      }
  }, [pmSearch, pmEmailList]);
  
  // Handle PD Email search
  useEffect(() => {
      if (pdSearch === '') {
          setFilteredPdEmails([]);
      } else {
          setFilteredPdEmails(pdEmailList.filter(email => email.email.toLowerCase().includes(pdSearch.toLowerCase())));
      }
  }, [pdSearch, pdEmailList]);
  
  const handlePmSearchChange = (e) => {
      setPmSearch(e.target.value);
  };

  const handlePdSearchChange = (e) => {
      setPdSearch(e.target.value);
  };

  const handlePmEmailSelect = (email) => {
      setPmSearch(email); // Auto-fill PM input with selected email
      setFilteredPmEmails([]); // Hide suggestions after selection
  };

  const handlePdEmailSelect = (email) => {
      setPdSearch(email); // Auto-fill PD input with selected email
      setFilteredPdEmails([]); // Hide suggestions after selection
  };


  const openCreateProjectPopup = async () => {
    // Fetch PM and PD email lists
    const response = await queuedApiFetch(`/project/get_initiate_new_project`);
    const data = await response;

    if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
        const pmEmailList = data.data.pm_email_list;
        const pdEmailList = data.data.pd_email_list;

        MySwal.fire({
            title: '',
            html: `
                <div class="popup-container">        
                    <div class="popup-body">
                        <div class="popup-field">
                            <label for="projectType">Project Type *</label>
                            <select id="projectType" style="width: 200px; border-radius: 0;" class="popup-input">
                                <option value="" selected>Select Project Type</option>
                                <option value="SC">SC</option>
                                <option value="SN">SN</option>
                            </select>
                        </div>
                        <div class="popup-field">
                            <label for="projectName">Project Name *</label>
                            <input id="projectName" type="text" class="popup-input" placeholder="Enter Project Name">
                        </div>

                        <div class="popup-field">
                            <label for="pmName">PM Name *</label>
                             <select id="pmName" style="width: 200px; border-radius: 0;" class="popup-input">
                                <option value="" selected>Select PM Name</option>
                                 ${pmEmailList.map(email => `<option value="${email.email}">${email.name}</option>`).join('')}
                            </select>
                        </div>

                        <div class="popup-field">
                            <label for="pdName">PD Name *</label>
                             <select id="pdName" style="width: 200px; border-radius: 0;" class="popup-input">
                                <option value="" selected>Select PD Name</option>
                                 ${pdEmailList.map(email => `<option value="${email.email}">${email.name}</option>`).join('')}
                            </select>
                        </div>
                    </div>
                </div>
            `,
            showCancelButton: true,
            confirmButtonText: 'Submit',
            cancelButtonText: 'Cancel',
            focusConfirm: false,
            customClass: {
                popup: 'custom-popup',
                cancelButton: 'cancel-button',
                confirmButton: 'confirm-button',
            },
            reverseButtons: true,
            allowOutsideClick: false,

            preConfirm: async () => {
                const projectName = document.getElementById('projectName').value;
                const projectType = document.getElementById('projectType').value;
                const account = 'NUS CPMS';
                const staticProjectType = 'Education Facility';
                // const scNumber = document.getElementById('scNumber').value;
                const pmName = document.getElementById('pmName').value;
                const pdName = document.getElementById('pdName').value;
                const projectNumber = '';
                
                // Validate the required fields
                if (!projectType || !projectName || !pmName || !pdName) {
                    Swal.showValidationMessage('Please fill out all required fields');
                    return false;
                }

                const sendData = {
                    project_name: projectName,
                    project_number: projectNumber,
                    account: account,
                    project_account: staticProjectType,
                    project_type: projectType,
                    PM_Name : pmName,
                    PD_Name : pdName,
                    User_Email: getUserEmail
                };

                try {
                    Swal.showLoading();

                    const requestOptions = {
                        method: 'POST',
                        // headers: {
                        //     'Content-Type': 'application/json',
                        //     'ngrok-skip-browser-warning': '69420',
                        // },
                        body: JSON.stringify(sendData),
                    };

                    const response = await queuedApiFetch('/project/insertprojectdetails', requestOptions);
                    const result = await response;

                    if (result.apistatus.Status_Code === 200 && result.apistatus.Status_Description.toLowerCase() === 'success') {
                        await getProjectList();
                        showToast.success('Project Created Successfully');
                        return true; // Close the popup
                    } else {
                        Swal.showValidationMessage(result.apistatus.Status_Description || 'Error occurred. Please try again.');
                        return false;
                    }
                } catch (error) {
                    console.error('Error saving data:', error);
                    Swal.showValidationMessage('Something went wrong. Please try again.');
                    return false;
                }
            },
        }).then((result) => {
            if (result.isConfirmed) {
                console.log('Project created successfully!');
            }
        }).catch((errorMessage) => {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: errorMessage,
            });
        });
    } else {
        console.error('Failed to load PM and PD data');
    }
};



    // for sorting icon implementation 


    const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });

    const sortRows = (rows, config) => {
      const sortedRows = [...rows];
      if (config.key) {
          sortedRows.sort((a, b) => {
              let aValue = a[config.key];
              let bValue = b[config.key];
  
              // Handle sorting for SC_Number field by extracting numbers after '_'
              if (config.key === 'SC_Number') {
                  const extractNumber = (value) => {
                      const match = value.match(/_(\d+)$/); // Match numbers after the last '_'
                      return match ? parseInt(match[1], 10) : 0; // Return the number after '_' or 0 if not found
                  };
  
                  aValue = extractNumber(aValue);
                  bValue = extractNumber(bValue);
              } else {
                  // For other fields (e.g., Proj_Name), perform normal string comparison
                  if (typeof aValue === 'string') {
                      aValue = aValue.toLowerCase();
                  }
                  if (typeof bValue === 'string') {
                      bValue = bValue.toLowerCase();
                  }
              }
  
              // Compare the values and sort in the specified direction
              if (aValue < bValue) return config.direction === 'asc' ? -1 : 1;
              if (aValue > bValue) return config.direction === 'asc' ? 1 : -1;
              return 0;
          });
      }
      return sortedRows;
  };
   
    
    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };
    
    const sortedRows = sortRows(rows, sortConfig);
    // const filteredRows = selectedProject
    //     ? rows.filter(row => row.Proj_Name === selectedProject)
    //     : rows;        

    return (
        <div className="bodywrap">
            {loading && <FullscreenLoader />} 
            <div className="header">
                <div style={{display:'flex', columnGap:'1em', alignItems: 'center' }}>
                  {/* old code */}
                    {/* <button id="initiateNewProject" className="button" disabled={getUserAccess == 'project_admin' ? false : true} onClick={openCreateProjectPopup}>Initiate New Project</button> */}
                    {/* new code */}
                    {/* <button 
                      id="initiateNewProject" 
                      className={`${!GlobalPermissionChecker("NUS",['Admin']) ? 'button' : 'button-grey'}`} 
                    //   disabled={!(userPermission === 'account_admin' && getUserCompanyDetails === 'NUS')} 
                      disabled={GlobalPermissionChecker("NUS",['Admin'])}
                      onClick={async () => {
                        await openCreateProjectPopup(); // Call the function to open the popup
                      }}
                      title="Initiate New Project"
                    >
                      Initiate New Project
                    </button> */}
                    {(Init_new_proj_sts())?(
                      <button 
                      id="initiateNewProject" className="button" title="Initiate New Project"
                      onClick={async () => {
                        await openCreateProjectPopup(); // Call the function to open the popup
                      }}
                      
                    >
                      Initiate New Project
                    </button>
                    ): null }
                    {/* <button 
                      id="initiateNewProject" 
                      className={`button ${(userPermission === 'account_admin' && getUserCompanyDetails === 'NUS')?'':'hide'}`}
                      //className={`${!GlobalPermissionChecker("NUS",['Admin']) ? 'button' : 'button-grey'}`} 
                    //   disabled={!(userPermission === 'account_admin' && getUserCompanyDetails === 'NUS')} 
                      //disabled={GlobalPermissionChecker("NUS",['Admin'])}
                      onClick={async () => {
                        await openCreateProjectPopup(); // Call the function to open the popup
                      }}
                      title="Initiate New Project"
                    >
                      Initiate New Project
                    </button> */}
                </div>
                <input type="text" id="searchBox" placeholder="Search" value={searchQuery} onChange={handleSearch} autoComplete="off" />
            </div>

            <div className="tablewrap" id="home_tablewrap" style={{width : '100%', height: 'auto', marginBottom: 120}}>
            <table id="projectTable">
                <thead>
                    <tr>
                        <th onClick={() => handleSort('SC_Number')}>
                            SC / SN No.&nbsp;&nbsp;
                            <FontAwesomeIcon icon={sortConfig.key === 'SC_Number' ? (sortConfig.direction === 'asc' ? faSortUp : faSortDown) : faSort} />
                        </th>
                        <th onClick={() => handleSort('Proj_Name')}>
                            Project Name&nbsp;&nbsp;
                            <FontAwesomeIcon icon={sortConfig.key === 'Proj_Name' ? (sortConfig.direction === 'asc' ? faSortUp : faSortDown) : faSort} />
                        </th>
                        <th>GFA</th>
                        {(Cost_data_sts("NUS",['Project Manager (PM)','Project Director (PD)']))?(
                          <>
                          <th>Total Project Cost (w GST)</th>
                        <th>Total Development Cost</th>
                        <th>Construction Cost</th>
                          </>
                        ):null}
                        {/* <th>Total Project Cost (w GST)</th>
                        <th>Total Development Cost</th>
                        <th>Construction Cost</th> */}
                        <th>Project Stage</th>
                        <th>Work progress Status (%)</th>
                    </tr>
                </thead>
                <tbody>
                    {sortedRows.length === 0 ? (
                        <tr>
                            <td colSpan="8" style={{ textAlign: 'center', height: '100px', verticalAlign: 'middle', padding: '20px' }}>
                                {loading ? 'Loading...' : 'No records found'}
                            </td>
                        </tr>
                    ) : (
                        sortedRows.filter((row) => !selectedProject || row.Proj_Name === selectedProject).map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                <td className="undescription-column">{row.SC_Number}</td>
                                <td className="total-column" style={{ cursor: 'pointer' }} onClick={() => goToSelectedProject(row.Proj_Number)}>
                                    {row.Proj_Name}
                                </td>
                                <td className="total-column">{row.GFA}</td>
                                {/* <td className="total-column">{getUserCompanyDetails === 'NUS' && (userPermission === 'project_admin' || userPermission === 'account_admin') ? formatCurrency(row.Proj_Cost) : ""}</td>  
                                <td className="total-column">{getUserCompanyDetails === 'NUS' && (userPermission === 'project_admin' || userPermission === 'account_admin') ? formatCurrency(row.Proj_Approved_Budget) : ""}</td>
                                <td className="total-column">{getUserCompanyDetails === 'NUS' && (userPermission === 'project_admin' || userPermission === 'account_admin') ? formatCurrency(row.Construction_Cost) : ""}</td> */}
                                
                                 {(Cost_data_sts("NUS",['Project Manager (PM)','Project Director (PD)']))?(
                                  <>
                                    <td className="total-column">{formatCurrency(row.Proj_Cost)}</td>  
                                    <td className="total-column">{formatCurrency(row.Proj_Approved_Budget) }</td>
                                    <td className="total-column">{ formatCurrency(row.Construction_Cost)}</td>
                                  </>
                                 ):null}

                                <td className="total-column">{row.Proj_Stage}</td>
                                <td className="total-column">{(row.Proj_Progress_Status*100)?.toFixed(2)}</td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
            </div>
        </div>
    );
}

export default Homeiframe;
